<template>
  <q-dialog
    :model-value="modelValue"
    :class="strToObj(contentClass, {'message-dialog': true})"
    :no-backdrop-dismiss="loading || noBackdropDismiss"
    :no-esc-dismiss="loading"
    :persistent="persistent"
    @before-show="$emit('beforeShow')"
    @show="onShowDialog"
    @hide="$emit('hide')"
    @update:model-value="(val) => $emit('update:modelValue', val)"
  >
    <q-card
      :style="cardStyle"
      :class="cardClass"
    >
      <q-toolbar v-if="!hasToolbarSlot">
        <q-btn
          v-if="withClose"
          v-close-popup
          dense
          flat
          round
          :icon="closeIcon"
          :disable="loading"
          @click="$emit('closeClick')"
        />
        <page-toolbar-title
          v-if="title"
          :class="{'q-ml-xs': !withClose}"
        >
          {{ title }}
        </page-toolbar-title>
      </q-toolbar>
      <slot
        v-else
        name="toolbar"
      />
      <q-card-section
        v-if="hasDefaultSlot"
        class="q-pt-none"
      >
        <slot />
      </q-card-section>
      <slot name="after" />
      <q-toolbar
        v-if="hasActionsSlot"
        :class="{'column items-stretch q-px-none q-pb-sm': column}"
      >
        <q-space />
        <slot name="actions" />
      </q-toolbar>
    </q-card>
  </q-dialog>
</template>

<script>
import { strToObj } from 'src/helpers/globals'

/**
 * MessageDialog displays a notice to the user and the option of performing an action
 *
 * SLOTS:
 * - default: default message content to display * - actions: button actions to display at the bottom
 */
export default {
  props: {
    // Is dialog opened
    modelValue: {
      type: Boolean,
      required: true
    },
    // If loading, the dialog cannot be closed (etc)
    loading: {
      type: Boolean,
      default: false
    },
    noBackdropDismiss: {
      type: Boolean,
      default: false
    },
    // Dialog title
    title: {
      type: String
    },
    // Show the close button at the top left
    withClose: {
      type: Boolean,
      default: false
    },
    // Width of the dialog
    width: {
      type: String,
      default: '450px'
    },
    cardClass: {
      type: [String, Object]
    },
    contentClass: {
      type: [String, Object]
    },
    // If withClose=true, define the icon to use in the button
    closeIcon: {
      type: String,
      default: 'mdi-close'
    },
    // Disable closing the dialog from clicking outside the box
    persistent: {
      type: Boolean,
      default: false
    },
    // Buttons at bottom will be displayed in a column rather than row
    column: {
      type: Boolean,
      default: false
    },
    // Disable re-rendering the Help Center when this dialog is opened
    // Usually this option does not need to be altered.
    // It is a bug with interacting with inputs inside the Help Center if it is not the last DOM on the page
    skipHelpChecks: {
      type: Boolean,
      default: false
    }
  },
  emits: ['beforeShow', 'hide', 'update:modelValue', 'closeClick', 'show'],
  computed: {
    hasToolbarSlot () {
      return !!this.$slots.toolbar
    },
    hasActionsSlot () {
      return !!this.$slots.actions
    },
    hasDefaultSlot () {
      return !!this.$slots.default
    },
    cardStyle () {
      return {
        'width': '100%',
        'max-width': this.width,
        'z-index': 0
      }
    }
  },
  methods: {
    strToObj,
    onShowDialog () {
      this.$emit('show')
      if (!this.skipHelpChecks) {
        this.$bus.emit('help:rerender')
      }
    }
  }
}
</script>
